import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Billboard, H2 } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { BlogContainer } from './banner.atom'

class BlogBanner extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            banner: file(relativePath: { regex: "/blog-banner.png/" }) {
              ...fluidImage
            }
          }
        `}
        render={({ banner }) => (
          <BlogContainer>
            <H2>{intl.get('blog.banner.title')}</H2>
            <p>{intl.get('blog.banner.desc')}</p>
            <Billboard fluid={banner.childImageSharp.fluid} />
          </BlogContainer>
        )}
      />
    )
  }
}
export default BlogBanner
